export const getPrimaryCustomerAddress = state =>
  state.customerAddress.addresses.find(el => el.primary);

export const getCustomerAddresses = state => state.customerAddress.addresses;

export const isCustomerAddressesLoading = state => state.customerAddress.loading;
